import { SIMPLE_UI_CATEGORY, SIMPLE_UI_GUN, EVENT_SCHEMA_VERSION } from '../constants';

export const sendSimpleUiEvent = (event) => {
  console.log(`Publishing event: ${JSON.stringify(event)}`);
  const publishCdmEvents = window?.Shell?.v1?.analytics?.publishCdmEvents;

  if (!publishCdmEvents) {
    console.error('Shell.v1.analytics.publishCdmEvents is not defined');
    return;
  }

  publishCdmEvents([
    {
      dateTime: new Date().toISOString(),
      eventDetailType: SIMPLE_UI_GUN,
      eventCategory: SIMPLE_UI_CATEGORY,
      eventDetail: event,
      version: EVENT_SCHEMA_VERSION
    }
  ]);
};
